export default "__VITE_ASSET__tLJ7MhfE__"